import { render } from "./ChangePositionView.vue?vue&type=template&id=64171662&scoped=true"
import script from "./ChangePositionView.vue?vue&type=script&lang=js"
export * from "./ChangePositionView.vue?vue&type=script&lang=js"

import "./ChangePositionView.vue?vue&type=style&index=0&id=64171662&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64171662"]])

export default __exports__